import { useState } from "react";
import AddBusinessOwnerAction from "./AddBusinessOwnerAction";
import AddBusinessOwner from "./AddBusinessOwner";
import { AllRegisteredBusinessSteps } from "../..";
import styles from "../../RegisteredBusiness.module.scss";
import { ICorporateCustomer } from "../../../../hooks/useCorporateCustomers";

export enum BusinessInfoSteps {
  ADD_BUSINESS_OWNER_ACTION = "add_business_owner_action",
  ADD_BUSINESS_OWNER_STEPS = "add_business_owner_steps",
}

interface IBusinessOwnersInformation {
  handleProceed: (step: number) => void;
  formData: any;
  resumeCustomerData: ICorporateCustomer;
}

const BusinessOwnersInformation: React.FC<IBusinessOwnersInformation> = ({
  handleProceed,
  resumeCustomerData,
  formData,
}) => {
  const [currentStep, setCurrentStep] = useState(
    BusinessInfoSteps.ADD_BUSINESS_OWNER_ACTION,
  );

  const handleNextStep = (_step: BusinessInfoSteps) => {
    setCurrentStep(_step);
  };

  return (
    <div>
      {(() => {
        switch (currentStep) {
          case BusinessInfoSteps.ADD_BUSINESS_OWNER_ACTION:
            return <AddBusinessOwnerAction handleNextStep={handleNextStep} />;

          case BusinessInfoSteps.ADD_BUSINESS_OWNER_STEPS:
            return (
              <AddBusinessOwner
                handleProceed={handleProceed}
                resumeCustomerData={resumeCustomerData}
                formData={formData}
              />
            );

          default:
            return null;
        }
      })()}
    </div>
  );
};

export default BusinessOwnersInformation;
